import React from 'react';
import Icon from '../../../components/AppIcon';

const Footer = () => {
  const currentYear = new Date()?.getFullYear();

  const footerLinks = {
    legal: [
      { label: 'Privacy Policy', path: '/privacy-policy' },
      { label: 'Terms & Conditions', path: '/terms-conditions' },
      { label: 'Disclaimer', path: '/disclaimer' }
    ],
    company: [
      { label: 'About Us', path: '/about-us' },
      { label: 'How It Works', path: '/how-it-works' },
      { label: 'FAQ', path: '/faq' }
    ],
    support: [
      { label: 'Contact Us', path: '/contact' },
      { label: 'Safety Tips', path: '/safety' },
      { label: 'Report Abuse', path: '/report' }
    ]
  };

  return (
    <footer className="bg-card border-t border-border">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6 lg:px-8 py-8 md:py-12 lg:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10 lg:gap-12 mb-8 md:mb-12">
          <div className="space-y-4">
            <div className="flex items-center gap-3 mb-6">
              <img 
                src="/assets/images/Logo_NoBG-1769596999637.png" 
                alt="Bamchik Logo" 
                className="h-12 w-auto object-contain"
              />
              <div>
                <h2 className="text-xl md:text-2xl font-heading font-bold">Bamchik</h2>
                <p className="text-sm text-muted-foreground">Discreet Dating Platform</p>
              </div>
            </div>
            <p className="text-sm text-muted-foreground leading-relaxed">
              Your trusted platform for discreet, anonymous connections. Privacy-first dating for adults seeking meaningful relationships.
            </p>
            <div className="flex items-center gap-2 text-xs text-muted-foreground">
              <Icon name="ShieldCheck" size={14} color="var(--color-success)" />
              <span>SSL Secured & Encrypted</span>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-caption font-semibold text-foreground mb-4">Legal</h3>
            <ul className="space-y-3">
              {footerLinks?.legal?.map((link, index) => (
                <li key={index}>
                  <a
                    href={link?.path}
                    className="text-sm text-muted-foreground hover:text-primary transition-smooth inline-flex items-center gap-2"
                  >
                    {link?.label}
                    <Icon name="ExternalLink" size={12} />
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-caption font-semibold text-foreground mb-4">Company</h3>
            <ul className="space-y-3">
              {footerLinks?.company?.map((link, index) => (
                <li key={index}>
                  <a
                    href={link?.path}
                    className="text-sm text-muted-foreground hover:text-primary transition-smooth inline-flex items-center gap-2"
                  >
                    {link?.label}
                    <Icon name="ExternalLink" size={12} />
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-caption font-semibold text-foreground mb-4">Support</h3>
            <ul className="space-y-3">
              {footerLinks?.support?.map((link, index) => (
                <li key={index}>
                  <a
                    href={link?.path}
                    className="text-sm text-muted-foreground hover:text-primary transition-smooth inline-flex items-center gap-2"
                  >
                    {link?.label}
                    <Icon name="ExternalLink" size={12} />
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="pt-6 md:pt-8 border-t border-border">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-xs md:text-sm text-muted-foreground text-center md:text-left">
              © {currentYear} Bamchik. All rights reserved. For adults 18+ only.
            </p>
            <div className="flex items-center gap-4">
              <div className="flex items-center gap-2 text-xs text-muted-foreground">
                <Icon name="Globe" size={14} />
                <span>India</span>
              </div>
              <div className="flex items-center gap-2 text-xs text-muted-foreground">
                <Icon name="Lock" size={14} />
                <span>Secure Platform</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;